import Activity from '../entities/Activity';

const readActivitiesRecent = () => ({
  type: 'READ_ACTIVITIES_RECENT'
});

const successReadActivitiesRecent = (activities: Activity[]) => ({
  type: 'SUCCESS_READ_ACTIVITIES_RECENT',
  activities
});

export { readActivitiesRecent, successReadActivitiesRecent };



// WEBPACK FOOTER //
// ./src/actions/activity.ts